// Returns the total files state and progress for uppy uploader
const useGetUploaderProgressState = (uppy) => {
    const state = {
        pending: 0,
        paused: 0,
        uploading: 0,
        total: 0,
        uploaded: 0,
        cancelled: 0,
        processing: 0,
        failed: 0,
        progress: {
            bytesTotal: 0,
            bytesUploaded: 0,
        },
    };

    uppy.getFiles().forEach((file) => {
        state.total += 1;
        if (file.meta?.cancelled) {
            state.cancelled += 1;
            return;
        }

        if (file.isPaused) {
            state.paused += 1;
            return;
        }
        state.uploading +=
            file.progress.uploadStarted !== null &&
            file.isPaused !== true &&
            file.progress.uploadComplete !== true &&
            !file.error
                ? 1
                : 0;
        state.failed += file.error ? 1 : 0;
        state.pending += file.progress.uploadStarted === null ? 1 : 0;
        state.processing +=
            typeof file.progress.postprocess !== 'undefined' &&
            file.progress.postprocess !== null &&
            file.progress.postprocess.value === 0
                ? 1
                : 0;
        state.progress.bytesTotal += file.progress.bytesTotal;
        state.progress.bytesUploaded += file.progress.bytesUploaded;
        state.uploaded +=
            file.progress.uploadComplete === true &&
            typeof file.progress.postprocess === 'undefined'
                ? 1
                : 0;
    });

    return state;
};

export default useGetUploaderProgressState;
